<modal
  [id]="modalId"
  [header]="'Handshake Setup'"
  [headerIcon]="handshakeIcon"
  [closeButtonEnabled]="true"
  [widthClass]="'tw-w-full lg:tw-w-[600px]'"
  [heightClass]="'tw-h-auto tw-max-h-[90vh]'"
  [showFooterDivider]="false"
  (onCloseModal)="onCloseModal.emit()"
>
  <div slot="body" class="tw-flex tw-flex-col tw-gap-4 tw-py-2">
    @if (personas().length === 0) {
      <p class="tw-font-inter tw-text-sm tw-text-gray-500">No personas available for this event.</p>
    } @else {
      @for (persona of personas(); track persona.id ?? $index) {
        <app-handshake-persona-card
          [persona]="persona"
          [allPersonas]="personas()"
          [initialExpanded]="$index === 0"
        />
      }
    }
  </div>

  <div slot="footer" class="tw-w-full tw-px-6 tw-pb-6">
    <button
      type="button"
      class="tw-w-full tw-h-[52px] tw-rounded-lg tw-bg-blue-600 tw-font-inter tw-text-base tw-font-medium tw-text-white hover:tw-bg-blue-700 disabled:tw-bg-blue-300"
      [buttonSpinner]="isSaving()"
      (click)="onSave()"
    >
      Save
    </button>
  </div>
</modal>
